<div class="paesse-abgleichen">
    <div class="paesse-abgleichen__row">
        <button
            *ngIf="showToggleButton"
            (click)="toggleSearchField()"
            color="accent"
            mat-flat-button
            type="button"
            class="paesse-abgleichen__toggle"
        >
            <mat-icon>search</mat-icon>
            <span class="paesse-abgleichen__toggle-label">Pässe abgleichen</span>
        </button>

        <div *ngIf="showSearchField" class="search-field-container">
            <mat-form-field appearance="outline" class="search-field">
                <mat-label>Ohrmarke / Rinderpass</mat-label>
                <mat-icon matPrefix class="search-field__prefix">search</mat-icon>
                <input
                    [formControl]="searchCtrl"
                    matInput
                    [placeholder]="lastScannedValue || 'z.B. 276000959833330, DE0122556101 oder 10 Ziffern'"
                    autocomplete="off"
                    maxlength="15"
                    (input)="onInput($event)"
                    (keydown)="onKeyDown($event)"
                    (paste)="onPaste($event)"
                />
                <mat-hint>15 Ziffern (Pass), 12 Zeichen (DE…) oder 10 Ziffern (Ohrmarke)</mat-hint>
            </mat-form-field>

            <div *ngIf="isLoading" class="search-loading">
                <mat-spinner diameter="20"></mat-spinner>
            </div>

            <div *ngIf="navigationHint && !isLoading" class="paesse-navigation-hint">
                {{ navigationHint }}
            </div>

            <div
                *ngIf="!isLoading && searchResults.length > 0 && showTierlisteContainer"
                class="search-results"
            >
                <div
                    *ngFor="let tier of searchResults"
                    class="search-result-item"
                    [class.selected]="selectedTier?.gt_id === tier.gt_id"
                    [class.search-result-item--muted]="!tier.paesse_navigable"
                    (click)="selectTier(tier)"
                >
                    <div class="result-content">
                        <div class="tierliste-status">
                            <span
                                *ngIf="resolveTierlisteId(tier); else notInList"
                                class="in-tierliste"
                                [class.in-tierliste--navigable]="tier.paesse_navigable"
                            >
                                <mat-icon
                                    [color]="tier.paesse_navigable ? 'primary' : 'warn'"
                                    class="tierliste-status__icon"
                                >
                                    {{ tier.paesse_navigable ? 'check_circle' : 'info' }}
                                </mat-icon>
                                Tierliste #{{ resolveTierlisteId(tier) }}
                                <span *ngIf="getTierlisteStatusLabel(tier) as statusLabel" class="tierliste-status__phase">
                                    · {{ statusLabel }}
                                </span>
                            </span>
                            <ng-template #notInList>
                                <span class="not-in-tierliste">Keine Tierliste</span>
                            </ng-template>
                        </div>
                        <div *ngIf="tier.paesse_hint" class="tierliste-hint">{{ tier.paesse_hint }}</div>
                    </div>
                </div>
            </div>

            <div
                *ngIf="!isLoading && searchCtrl.value && searchResults.length === 0"
                class="no-results"
            >
                <span class="no-results__text">Keine Tiere mit dieser Ohrmarke gefunden</span>
            </div>
        </div>
    </div>
</div>
